import { Box, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { useRefreshBarStyles } from './style';





export default function AutoRefreshBar({ onRefresh }) {
  const config = useApi(configApiRef);
  const refreshIntervalInSeconds = config.getNumber(
    'deploymentStatus.refreshIntervalInSeconds',
  );

  const [counter, setCounter] = React.useState(refreshIntervalInSeconds);
  const classes = useRefreshBarStyles();

  useEffect(() => {
    let timer;
    if (counter > 0) {
      timer = setInterval(() => setCounter(counter - 1), 1000);
    } else {
      setCounter(refreshIntervalInSeconds);
      onRefresh();
    }
    return () => clearInterval(timer);
  }, [counter, onRefresh]);

  return (
    React.createElement(Box, { className: classes.container,}
      , React.createElement(Box, { className: classes.copyButton, onClick: onRefresh,}
        , React.createElement(RefreshIcon, { style: { width: 16, height: 16 },} )
      )
      , React.createElement(Box, { className: classes.countdownWrapper,}
        , React.createElement(Typography, { variant: "body2", color: "secondary",}, "Auto refresh in "

        )
        , React.createElement(Typography, { variant: "body2",}, counter, " secs" )
      )
    )
  );
}
